import Work1 from "../../assets/work1.jpg"
import Work2 from "../../assets/work2.jpg"
import Work3 from "../../assets/work3.jpg"
import Work4 from "../../assets/work4.jpg"
import Work5 from "../../assets/work5.jpg"
import Work6 from "../../assets/work6.jpg"
import Work7 from "../../assets/work7.jpg"


export const  projectsData = [
    {
      id: 1,
      image: Work1,
      title: "Angkringan Web",
      category: "web",
      link: "https://angkringan-3.vercel.app/",
    },
    {
      id: 2,
      image: Work2,
      title: "HealthyCare Web",
      category: "web",
      link: "https://healthy-care.netlify.app/",
    },
    {
      id: 3,
      image: Work3,
      title: "Magang dan Studi Independen Batch 4",
      category: "sertifikat",
      link: "https://drive.google.com/file/d/1Vgb0Z3EKQ70-mkhrn5rwFEsMNLXxJ02V/view?usp=sharing",
    },
    {
      id: 4,
      image: Work4,
      title: "Magang dan Studi Independen Batch 6",
      category: "sertifikat",
      link: "https://drive.google.com/file/d/1qL3Hyp6d_6wRd7FtMHVwHFg5sDhGfVUJ/view?usp=sharing",
    },
    {
      id: 5,
      image: Work5,
      title: "Sertifikat Data Analyst",
      category: "sertifikat",
      link: "https://drive.google.com/file/d/1RD01ikRboqGHqQtIiSq7R4PxBajwQQix/view?usp=sharing",
    },
    {
      id: 6,
      image: Work6,
      title: "Portofolio as IT Support Database",
      category: "data",
      link: "https://drive.google.com/file/d/1y3WcXpu2nKkBLe-7buYIWXs-R5Lel0Rn/view?usp=sharing"
    },
    {
    id: 7,
    image: Work7,
    title: "Sertifikat SQL for Data Analysis",
    category: "sertifikat",
    link: "https://storage.googleapis.com/myskill-v2-certificates/topic-DDujKITvy3VJuXrhC2ou/1WN1xL8l9wPCRld0X9aL6HSuqn12-7k7RsBUKuIjzvKJm3aBH.pdf"
    },
  ];

  export const projectsNav = [
    {
        name: 'all',
    },
    {
        name: 'web',
    },
    {
        name: 'sertifikat',
    },
    {
        name: 'data'
    }
  ]